// Module
var code = "<div class=\"checkbox\" style=\"margin:0;text-align:center\"> <label> <input type=\"checkbox\" ng-model=\"vm.model\" ng-disabled=\"vm.disabled\" name=\"{{vm.name}}\"/> </label> </div>";
// Exports
module.exports = code;